import MarkerSymbol from './MarkerSymbol';
import GeometryFactory from '../geometry/GeometryFactory';

/**
 * 正方形点符号.
 */
export default class SquareMarkerSymbol extends MarkerSymbol {
    constructor(options) {
        super(options);

        /**
         * 符号的大小
         * @type {Number}
         */
        this.size = 10;

        this.type = 'SquareMarkerSymbol';

        this.fromJson(options);
    }

    fromJson(json) {
        super.fromJson(json);

        this._setValue('size', json.size);
    }

    toJson() {
        const json = super.toJson();

        json.size = this.size;

        return json;
    }

    /**
     * 重写父类方法,以正方形绘制点符号.
     * @param {Object} ctx - 设备上下文,通过canvas.getContext('2d')方法获得.
     * @return {undefined}
     */
    _drawContent(ctx) {
        // 设置绘制环境
        ctx.fillStyle = this.color;
        ctx.globalAlpha = this.opacity;

        // 获取绘制内容
        const geometry = this._getContentGeometry();

        ctx.beginPath();
        // 绘制
        this._drawLineString(ctx, geometry);
        ctx.closePath();

        ctx.fill();
    }

    /**
     * 描边填充的矩形.
     * @param {Object} ctx - 设备上下文,通过canvas.getContext('2d')方法获得.
     * @return {undefined}
     */
    _drawOutLine(ctx) {
        // 设置绘制环境
        ctx.lineWidth = this.outLine.width;
        ctx.strokeStyle = this.outLine.color;
        ctx.globalAlpha = this.outLine.opacity;

        // 绘制
        ctx.stroke();
    }

    /**
     * 获得要绘制的几何.
     * @returns {Object}.
     */
    _getContentGeometry() {
        return this.getOriginBound()
            .toLineString();
    }

    /**
     * 返回符号在局部坐标系下的bound
     * x方向为宽度，y方向为高度
     * @returns {Object} bound
     */
    getOriginBound() {
        const gf = GeometryFactory.getInstance();
        const bound = gf.createBound(null, this.size, this.size);
        return bound;
    }
}
